// Container imports
const TopCallToActionRecord = require('./record')

function topCallToActionReducer(state = new TopCallToActionRecord(), action) {
  switch (action.type) {
    // No actions; this reducer exists to silence a react-redux warning for now.
    default:
      return state
  }
}

module.exports = topCallToActionReducer
